/*
 * action types
 */

export const TOGGLE_DASHBOARD_LOADING = 'TOGGLE_DASHBOARD_LOADING';
export const TOGGLE_SHOW_REQUEST_PROGRESS_BAR =
  'TOGGLE_SHOW_REQUEST_PROGRESS_BAR';
export const HANDLE_NOTIFICATION_MESSAGE = 'HANDLE_NOTIFICATION_MESSAGE';
export const WEB_APP_ONLINE = 'WEB_APP_ONLINE';